import React from 'react';
import './toast-message.scss';
import { useEffect } from 'react';
import TealiumEvents from 'src/helpers/tealium-events';

import { InputErrorIcon } from 'src/assets/images';
import { BlueTick } from 'src/assets/images';

export default function ToastMessage({ toast, removeToast }) {
  useEffect(() => {
    if (toast.type?.toLowerCase() === 'error' && !toast.suppressTealiumEvent) {
      if (!!toast.tealiumError) {
        toast.tealiumError(toast.message);
      } else {
        TealiumEvents.onToastError(toast.message, toast.errorCode, toast.isUserError);
      }
    }
  }, []);

  return (
    <div className={`ToastMessage ${toast.type?.toLowerCase() || ''} ${toast.className || ''}`}>
      <div className="columns level is-mobile is-vcentered">
        <div className={`column`}>
          <div className="field-text has-text-left">
            {toast.type?.toLowerCase() === 'error' && (
              <img className="error-image" src={InputErrorIcon} />
            )}
            {toast.type?.toLowerCase() === 'info' && <img className="info-image" src={BlueTick} />}
            <span className="message">
              <p className="message-main content-large-extra">{toast.message}</p>

              <p className="message-subtitle content-small">{toast.messageSubtitle}</p>

              {toast.link && (
                <a className="action-text" href={toast.link}>
                  {toast.linkText}
                </a>
              )}
              {toast.fn && (
                <a className="action-text" onClick={toast.fn}>
                  {toast.fnText}
                </a>
              )}
            </span>
          </div>
        </div>

        {toast.actionButtonText && toast.actionButtonOnClick && (
          <a
            className="column is-narrow action-button"
            onClick={() => {
              removeToast();

              toast.actionButtonOnClick();
            }}
            target="_blank"
          >
            {toast.actionButtonText}
          </a>
        )}

        <div
          className="column is-narrow cross-container has-text-right"
          onClick={() => {
            removeToast();
          }}
          automationid="Error_Handling_Div_Toast_Message_Button_Close"
        >
          <span className="icon-icon-close toast-close-button" />
        </div>
      </div>
    </div>
  );
}
